import * as angular from 'angular';

import HeaderName from './header/header.directive';
import NavName from './nav/nav.directive';

let requires = [HeaderName, NavName];

export default angular.module("aps.layout", requires).name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/layout/index.ts